import React from "react";
import { Box, Typography } from "@mui/material";
import { useKivunovaTranslation } from "@kivunova/kivufrontendcommon";
import AppButton from "../common/AppButton";

interface NoCustomerListFoundProps {
  onAddClick?: () => void;
}

const NoCustomerListFound: React.FC<NoCustomerListFoundProps> = ({
  onAddClick
}) => {
  const { t } = useKivunovaTranslation();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="400px"
      gap={3}
    >
      <Typography variant="h6" color="text.primary" fontWeight="bold">
        {t("no-customers-found", "No customers found")}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {t(
          "no-customers-description",
          "Get started by adding your first customer"
        )}
      </Typography>
      {onAddClick && (
        <Box>
          <AppButton variant="primary" onClick={onAddClick}>
            {t("add-customer", "Add Customer")}
          </AppButton>
        </Box>
      )}
    </Box>
  );
};

export default NoCustomerListFound;
